// extracted by mini-css-extract-plugin
module.exports = {"section":"Intro_section__pk0Te","image":"Intro_image__tog59","title":"Intro_title__FrHlP","description":"Intro_description__n0Qj7"};